import { countrySpecs, isValidIBAN } from 'ibantools';

// ESLint bans importing ibantools anywhere else, so these overrides reach every IBAN check.
// ibantools is stricter than the server for these countries:
// - CI, SN: banks also use a two-character or letter + digit bank prefix (CI93CI0080..., SN12K0010...), Simplify/ibantools#630
// - BY: bank codes may carry digits (registry 4!c), Simplify/ibantools#687
// - PK, PS: account parts may carry letters (registry 16!c / 21!c)
const BBAN_FORMAT_OVERRIDES: Record<string, string> = {
  BY: '^[A-Z0-9]{4}[0-9]{4}[A-Z0-9]{16}$',
  CI: '^[A-Z0-9]{2}[0-9]{22}$',
  PK: '^[A-Z]{4}[A-Z0-9]{16}$',
  PS: '^[A-Z]{4}[A-Z0-9]{21}$',
  SN: '^[A-Z0-9]{2}[0-9]{22}$',
};

Object.entries(BBAN_FORMAT_OVERRIDES).forEach(([country, format]) => {
  countrySpecs[country].bban_regexp = format;
});

// National check digits (PL, ES, FR, ...) aren't enforced: the server doesn't, and sandbox IBANs satisfy only mod-97.
Object.values(countrySpecs).forEach((spec) => {
  delete spec.bban_validation_func;
});

// Expects the electronic format - upper case, no separators; ibantools doesn't normalize.
export function isValidElectronicIban(iban: string): boolean {
  return isValidIBAN(iban);
}
